// For Elevar in the Cart View event it requires us to list the collection appears in.

const elevarCartProductList = [
  {
    type: 'Mattress',
    list: '/collections/mattresses'
  },
  {
    type: 'Base',
    list: '/collections/furniture'
  },
  {
    type: 'Pillow',
    list: '/collections/pillows'
  },
  {
    type: 'Sheet',
    list: '/collections/blankets-sheets'
  },
  {
    type: 'Topper',
    list: '/collections/protectors-and-toppers'
  },
  {
    type: 'Blanket',
    list: '/collections/blankets-sheets'
  },
  {
    type: 'Bedding',
    list: '/collections/blankets-sheets'
  }
];

export default elevarCartProductList;
